// extracted by mini-css-extract-plugin
export default {"hightLight":"hightLight_hightLight__cxRV+"};